import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Toast from './components/Toast';
import CookieConsent from './components/CookieConsent';
import ChatBot from './components/ChatBot';
import './index.css';

// Code-split every page so only the current page's JS loads initially.
// This dramatically reduces initial bundle size and improves LCP / CWV scores.
const Home             = lazy(() => import('./pages/Home'));
const CategoryPage     = lazy(() => import('./pages/CategoryPage'));
const ShayariDetailPage = lazy(() => import('./pages/ShayariDetailPage'));
const FavoritesPage    = lazy(() => import('./pages/FavoritesPage'));
const PoetsPage        = lazy(() => import('./pages/PoetsPage'));
const PoetDetailPage   = lazy(() => import('./pages/PoetDetailPage'));
const SearchPage       = lazy(() => import('./pages/SearchPage'));
const AboutPage        = lazy(() => import('./pages/AboutPage'));
const ContactPage      = lazy(() => import('./pages/ContactPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsPage        = lazy(() => import('./pages/TermsPage'));
const CopyrightPage    = lazy(() => import('./pages/CopyrightPage'));
const PosterPage       = lazy(() => import('./pages/PosterPage'));
const NotFoundPage     = lazy(() => import('./pages/NotFoundPage'));

const PageLoader = () => (
  <div style={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', minHeight:'60vh', gap:'0.75rem' }}>
    <div style={{ fontSize:'2rem' }}>📖</div>
    <p style={{ color:'var(--text-muted)', fontSize:'0.9rem', margin:0 }}>Loading…</p>
  </div>
);

function App() {
  return (
    <AppProvider>
      <Router>
        <Navbar />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/"                     element={<Home />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/shayari/:id"          element={<ShayariDetailPage />} />
            <Route path="/favorites"            element={<FavoritesPage />} />
            <Route path="/poets"                element={<PoetsPage />} />
            <Route path="/poets/:poetSlug"      element={<PoetDetailPage />} />
            <Route path="/search"               element={<SearchPage />} />
            <Route path="/about"                element={<AboutPage />} />
            <Route path="/contact"              element={<ContactPage />} />
            <Route path="/privacy-policy"       element={<PrivacyPolicyPage />} />
            <Route path="/terms"                element={<TermsPage />} />
            <Route path="/copyright"            element={<CopyrightPage />} />
            <Route path="/poster"               element={<PosterPage />} />
            <Route path="*"                     element={<NotFoundPage />} />
          </Routes>
        </Suspense>
        <Footer />
        <Toast />
        <CookieConsent />
        <ChatBot />
      </Router>
    </AppProvider>
  );
}

export default App;
